export const paths = {
    customerMeetings: "/customer-meetings",
    inMeetingApp: "/in-meeting-app",
    organizerNoRecordingWarning: "/organizer-prompt",
    organizerMeetingTypePrompt: "/organizer-meeting-type-prompt",
    customerJoinsLobbyPrompt: "/customer-joins-lobby-prompt",
    screenSharingWarningPrompt: "/screen-sharing-warning",
};
